import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const masterDataSchema = new schema.Entity('masterData', {
    DOTCOLORS: [schemas.DOTCOLORS],
    PROPS: [schemas.PROPS],
    FNDIARYCATEGORY: [schemas.FNDIARYCATEGORY],
    PRMASTERSPECIALPROGTYPES: [schemas.PRMASTERSPECIALPROGTYPES],
    PTMASTERASHWORTH: [schemas.PTMASTERASHWORTH],
    PTMASTERBALANCE: [schemas.PTMASTERBALANCE],
    PTMASTERCOMPLHEP: [schemas.PTMASTERCOMPLHEP],
    PTMASTEREMPLTYPES: [schemas.PTMASTEREMPLTYPES],
    PTMASTERGOALLEVELS: [schemas.PTMASTERGOALLEVELS],
    PTMASTERGOALLEVELXREF: [schemas.PTMASTERGOALLEVELXREF],
    PTMASTERGOALLOA: [schemas.PTMASTERGOALLOA],
    PTMASTERGOALPDCXREF: [schemas.PTMASTERGOALPDCXREF],
    PTMASTERGOALPROGRESS: [schemas.PTMASTERGOALPROGRESS],
    PTMASTERGOALS: [schemas.PTMASTERGOALS],
    PTMASTERGOALTHRESHOLDS: [schemas.PTMASTERGOALTHRESHOLDS],
    PTMASTERHELPCONTACTS: [schemas.PTMASTERHELPCONTACTS],
    PTMASTERINDHEP: [schemas.PTMASTERINDHEP],
    PTMASTERLIVEENVIRON: [schemas.PTMASTERLIVEENVIRON],
    PTMASTERLIVESWITH: [schemas.PTMASTERLIVESWITH],
    PTMASTERNOTEACTIONS: [schemas.PTMASTERNOTEACTIONS],
    PTMASTERNOTESOURCES: [schemas.PTMASTERNOTESOURCES],
    PTMASTERNOTESTATUS: [schemas.PTMASTERNOTESTATUS],
    PTMASTERNOTETYPES: [schemas.PTMASTERNOTETYPES],
    PTMASTEROBJECTIVEPANELS: [schemas.PTMASTEROBJECTIVEPANELS],
    PTMASTERONLINERESOURCES: [schemas.PTMASTERONLINERESOURCES],
    PTMASTEROUTCOMES: [schemas.PTMASTEROUTCOMES],
    PTMASTERPAINRATING: [schemas.PTMASTERPAINRATING],
    PTMASTERPEDSAGETYPES: [schemas.PTMASTERPEDSAGETYPES],
    PTMASTERPLACEOFSERVICE: [schemas.PTMASTERPLACEOFSERVICE],
    PTMASTERPLANDURATIONS: [schemas.PTMASTERPLANDURATIONS],
    PTMASTERPLANTIMES: [schemas.PTMASTERPLANTIMES],
    PTMASTERPROGNOSIS: [schemas.PTMASTERPROGNOSIS],
    PTMASTERPUSHTYPES: [schemas.PTMASTERPUSHTYPES],
    PTMASTERREHABPOT: [schemas.PTMASTERREHABPOT],
    PTMASTERREPORTS: [schemas.PTMASTERREPORTS],
    PTMASTERRESPPATTERNS: [schemas.PTMASTERRESPPATTERNS],
    PTMASTERRESPPOSITIONS: [schemas.PTMASTERRESPPOSITIONS],
    PTMASTERSENSORYMODULATION: [schemas.PTMASTERSENSORYMODULATION],
    PTMASTERSTRENGTH: [schemas.PTMASTERSTRENGTH],
    PTMASTERSUBJECTIVE: [schemas.PTMASTERSUBJECTIVE],
    PTMASTERTHRESHOLDS: [schemas.PTMASTERTHRESHOLDS],
    PTMASTERTOLERANCE: [schemas.PTMASTERTOLERANCE],
    PTMASTERTONESCORES: [schemas.PTMASTERTONESCORES],
    PTMASTERWCPDC: [schemas.PTMASTERWCPDC],
    PTMASTERWCPDCFREQ: [schemas.PTMASTERWCPDCFREQ],
    PTMASTERWCPDCWEIGHT: [schemas.PTMASTERWCPDCWEIGHT],
    PTMASTERWCDOLPDCWEIGHTFREQ: [schemas.PTMASTERWCDOLPDCWEIGHTFREQ],
    PTMASTERWCDOLPDCWEIGHT: [schemas.PTMASTERWCDOLPDCWEIGHT],
    PTMASTERWCDOLPDCWEIGHTFREQXREF: [schemas.PTMASTERWCDOLPDCWEIGHTFREQXREF],
    PTMASTERWCPDCXREF: [schemas.PTMASTERWCPDCXREF],
    PTMASTERWCSTATUS: [schemas.PTMASTERWCSTATUS],
    MLMASTERAQUATICS: [schemas.MLMASTERAQUATICS],
    MLMASTERGAITASSDEV: [schemas.MLMASTERGAITASSDEV],
    MLMASTERGAITLEVASS: [schemas.MLMASTERGAITLEVASS],
    MLMASTERGAITSURFACE: [schemas.MLMASTERGAITSURFACE],
    MLMASTERMANUAL: [schemas.MLMASTERMANUAL],
    MLMASTERMODALITIES: [schemas.MLMASTERMODALITIES],
    MLMASTERNEURO: [schemas.MLMASTERNEURO],
    MLMASTEROTHER: [schemas.MLMASTEROTHER],
    MLMASTERREQUESTTYPES: [schemas.MLMASTERREQUESTTYPES],
    MLMASTERSELFCARE: [schemas.MLMASTERSELFCARE],
    MLMASTERSPEECH: [schemas.MLMASTERSPEECH],
    MLMASTERSTANDARDIZEDTESTS: [schemas.MLMASTERSTANDARDIZEDTESTS],
    MLMASTERTHERACT: [schemas.MLMASTERTHERACT],
    MLMASTERTHEREX: [schemas.MLMASTERTHEREX],
    MLMASTERWORKACTIVITIES: [schemas.MLMASTERWORKACTIVITIES],
    FNJOBTITLES: [schemas.FNJOBTITLES],
    CWEVALTYPES: [schemas.CWEVALTYPES],
    CWODGDETAILS: [schemas.CWODGDETAILS],
    CWEVALTYPESODGDETAILSXREF: [schemas.CWEVALTYPESODGDETAILSXREF],
    PTOBJECTIVESPECTESTSGROUPDETAILS: [schemas.PTOBJECTIVESPECTESTSGROUPDETAILS],
    PTERONOTESCHEMA: [schemas.PTERONOTESCHEMA],
    FNHELPGROUPS: [schemas.FNHELPGROUPS],
    PTAGETYPES: [schemas.PTAGETYPES],
    PTTHERAPYTYPES: [schemas.PTTHERAPYTYPES]
});
